module.exports = __webpack_public_path__ + "img/dsExclamacao.26379c86.svg";